// Modalidades del prompt oficial multi-cliente (espejo de Prompt.VARIANT_* del backend).
//
// Módulo compartido entre PromptCopyBlock (SetupGuideCard) y OfficialPromptsSection: hasta
// 2026-08-07 cada uno duplicaba las constantes MODE_* y el array de opciones, y ya habían
// empezado a divergir en el chrome. Una sola fuente para que la próxima modalidad no repita
// la historia — los tests de paridad fijan que ambos consumidores pasen por acá.
//
// Desde el ping de copiado (2026-08), cada variante viaja como OBJETO `{id, text, version}`
// (lo arma fetchAgencyPrompts): el id identifica QUÉ variante se copió y la versión alimenta
// el chip "v9 disponible". Con un backend viejo `id`/`version` vienen null y todo degrada a
// solo-texto (sin ping ni chip).
export const MODE_STUB = 'STUB';
export const MODE_ADDON = 'ADDON';
export const MODE_FULL = 'FULL';

// El stub (canal pull, F3) es el default cuando el backend lo sirve: bloque corto que entra
// siempre en el campo Instructions, y el cuerpo operativo lo entrega el conector actualizado
// — se pega una vez y los cambios llegan solos. Sin stub (backend viejo), default ADDON:
// pegarlo nunca destruye instrucciones que el GPT ya tuviera.
export function defaultPromptMode(prompts) {
    return prompts && prompts.stub ? MODE_STUB : MODE_ADDON;
}

// Opciones para PromptModalityChoice según qué modalidades sirvió el backend. FULL existe
// siempre (es el fallback histórico); stub y addon sólo si su fila está sembrada.
export function buildModalityOptions({t, prompts}) {
    const options = [];
    if (prompts && prompts.stub) {
        options.push({
            value: MODE_STUB,
            title: t('dashbo_mcp.setup.modality_stub'),
            description: t('dashbo_mcp.setup.modality_stub_desc'),
        });
    }
    if (prompts && prompts.addon) {
        options.push({
            value: MODE_ADDON,
            title: t('dashbo_mcp.setup.modality_keep_existing'),
            description: t('dashbo_mcp.setup.modality_keep_existing_desc'),
        });
    }
    options.push({
        value: MODE_FULL,
        title: t('dashbo_mcp.setup.modality_new_gpt'),
        description: t('dashbo_mcp.setup.modality_new_gpt_desc'),
    });
    return options;
}

// El prompt activo COMPLETO ({id, text, version}) según el modo elegido, con fallback al
// pack completo si la modalidad pedida no está disponible (backend viejo, fila sin sembrar).
export function resolveActivePrompt(mode, prompts) {
    if (!prompts) return null;
    if (mode === MODE_STUB && prompts.stub) return prompts.stub;
    if (mode === MODE_ADDON && prompts.addon) return prompts.addon;
    return prompts.full || null;
}

// Solo el texto activo — wrapper fino sobre resolveActivePrompt para quien no necesita
// id/versión (el preview, el aviso de límite de caracteres).
export function resolveActiveText(mode, prompts) {
    const active = resolveActivePrompt(mode, prompts);
    return active ? active.text : null;
}
